import React from "react";

const FurnitureAbout = () => {
  const brandPurple = "#bd06b3";
  const brandCyan = "#00bfff";

  const offerItems = [
    {
      title: "Living Room",
      desc: "Modern sofa sets, TV units and furniture designed for comfortable living spaces.",
      color: brandPurple,
    },
    {
      title: "Bedroom",
      desc: "Beds, wardrobes, dressing tables and storage solutions for modern bedrooms.",
      color: brandCyan,
    },
    {
      title: "Dining",
      desc: "Elegant dining tables and chairs designed for everyday family moments.",
      color: brandPurple,
    },
    {
      title: "Office Furniture",
      desc: "Functional executive desks, chairs and furniture for professional workspaces.",
      color: brandCyan,
    },
  ];

  const expertise = [
    "Modern Furniture",
    "Quality Materials",
    "Space Optimization",
    "Interior Solutions",
    "Contemporary Design",
    "Customer Service",
  ];

  const whyChoose = [
    {
      title: "Quality Materials",
      desc: "We focus on quality materials and reliable construction for everyday use.",
    },
    {
      title: "Modern Design",
      desc: "Our designs combine contemporary style with practical functionality.",
    },
    {
      title: "Comfort & Function",
      desc: "Furniture is designed to provide comfort while making the best use of available space.",
    },
    {
      title: "Customer Care",
      desc: "We value our customers and aim to provide dependable service before and after purchase.",
    },
  ];

  return (
    <div
      style={{
        fontFamily: "'Inter', 'Segoe UI', Arial, sans-serif",
        color: "#111827",
        background: "#fff",
        padding: "40px 20px 60px",
        marginTop: "-50px",
      }}
    >
      <div
        style={{
          maxWidth: "1440px",
          margin: "0 auto",
        }}
      >
        {/* ================= TOP HERO ================= */}
        <section
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "40px",
            alignItems: "center",
            marginBottom: "50px",
          }}
        >
          {/* Left Content */}
          <div>
            <div
              style={{
                fontSize: "13px",
                fontWeight: "700",
                color: brandPurple,
                letterSpacing: "1px",
                marginBottom: "12px",
                textTransform: "uppercase",
              }}
            >
              ✦ ICONIC FURNITURE
            </div>

            <h1
              style={{
                margin: "0 0 16px",
                fontSize: "36px",
                lineHeight: "1.25",
                fontWeight: "800",
                color: "#111827",
              }}
            >
              Modern Furniture{" "}
              <span style={{ color: brandPurple }}>For Better Living</span>
            </h1>

            <p
              style={{
                margin: "0 0 12px",
                maxWidth: "570px",
                fontSize: "15px",
                lineHeight: "1.6",
                color: "#64748b",
              }}
            >
              Iconic Furniture offers a distinctive range of chic, modern
              furniture. Our furniture selection for your home and office
              includes sofa sets, beds, dining tables, TV stands, cupboards,
              dressing tables, executive office furniture, and more.
            </p>

            <p
              style={{
                margin: 0,
                maxWidth: "570px",
                fontSize: "15px",
                lineHeight: "1.6",
                color: "#64748b",
              }}
            >
              We focus on combining practical design, quality materials,
              comfort, and modern aesthetics to create furniture that fits
              naturally into contemporary living spaces.
            </p>
          </div>

          {/* Hero Image */}
          <div
            style={{
              height: "320px",
              border: `1px solid ${brandPurple}33`,
              borderRadius: "12px",
              padding: "8px",
            }}
          >
            <img
              src="https://images.unsplash.com/photo-1555041469-a586c61ea9bc?auto=format&fit=crop&w=1200&q=85"
              alt="Modern Furniture"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "8px",
                display: "block",
              }}
            />
          </div>
        </section>

        {/* ================= WHAT WE OFFER ================= */}
        <section style={{ marginBottom: "50px" }}>
          <div
            style={{
              textAlign: "center",
              marginBottom: "32px",
            }}
          >
            <h2
              style={{
                margin: 0,
                fontSize: "28px",
                fontWeight: "800",
                color: brandPurple,
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              WHAT WE <span style={{ color: brandCyan }}>OFFER</span>
            </h2>

            <p
              style={{
                margin: "8px 0 0",
                fontSize: "15px",
                color: "#64748b",
              }}
            >
              Furniture solutions designed for modern living.
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: "20px",
            }}
          >
            {offerItems.map((item, index) => (
              <div
                key={index}
                style={{
                  minHeight: "140px",
                  padding: "24px 20px",
                  border: `1px solid ${item.color}33`,
                  borderRadius: "12px",
                  background: "#fff",
                }}
              >
                <div
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "8px",
                    background: `${item.color}15`,
                    color: item.color,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "16px",
                    marginBottom: "16px",
                  }}
                >
                  {index === 0
                    ? "▦"
                    : index === 1
                      ? "⌂"
                      : index === 2
                        ? "◆"
                        : "▣"}
                </div>

                <h3
                  style={{
                    margin: "0 0 8px",
                    fontSize: "18px",
                    fontWeight: "700",
                    color: item.color,
                  }}
                >
                  {item.title}
                </h3>

                <p
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    lineHeight: "1.5",
                    color: "#64748b",
                  }}
                >
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* ================= OUR EXPERTISE ================= */}
        <section style={{ marginBottom: "50px" }}>
          <div
            style={{
              textAlign: "center",
              marginBottom: "24px",
            }}
          >
            <h2
              style={{
                margin: 0,
                fontSize: "28px",
                fontWeight: "800",
                color: brandPurple,
                textTransform: "uppercase",
              }}
            >
              OUR <span style={{ color: brandCyan }}>EXPERTISE</span>
            </h2>

            <p
              style={{
                margin: "8px 0 0",
                fontSize: "15px",
                color: "#64748b",
              }}
            >
              Thoughtful furniture solutions built around modern lifestyles.
            </p>
          </div>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            {expertise.map((item, index) => {
              const color = index % 2 === 0 ? brandPurple : brandCyan;

              return (
                <span
                  key={index}
                  style={{
                    border: `1px solid ${color}40`,
                    color: color,
                    padding: "8px 16px",
                    borderRadius: "20px",
                    fontSize: "13px",
                    fontWeight: "600",
                    background: "#fff",
                  }}
                >
                  ✓ &nbsp;{item}
                </span>
              );
            })}
          </div>
        </section>

        {/* ================= MISSION + VISION ================= */}
        <section style={{ marginBottom: "50px" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "24px",
            }}
          >
            {/* Mission */}
            <div
              style={{
                border: `1px solid ${brandPurple}33`,
                borderRadius: "12px",
                padding: "28px",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "700",
                  color: brandPurple,
                  textTransform: "uppercase",
                  marginBottom: "8px",
                }}
              >
                01 / Our Mission
              </div>

              <h3
                style={{
                  margin: "0 0 12px",
                  fontSize: "20px",
                  fontWeight: "700",
                  color: "#111827",
                }}
              >
                Designing Better Everyday Spaces
              </h3>

              <p
                style={{
                  margin: "0 0 10px",
                  fontSize: "14px",
                  lineHeight: "1.6",
                  color: "#64748b",
                }}
              >
                We are passionate about maximizing space, whether through our
                concept studio or sustainable designs. Our objective is to close
                the gap between what people want from modern living and what is
                available in the market.
              </p>

              <p
                style={{
                  margin: 0,
                  fontSize: "14px",
                  lineHeight: "1.6",
                  color: "#64748b",
                }}
              >
                We strive to make quality furniture accessible while maintaining
                thoughtful design, functionality, comfort, and lasting value.
              </p>
            </div>

            {/* Vision */}
            <div
              style={{
                border: `1px solid ${brandCyan}33`,
                borderRadius: "12px",
                padding: "28px",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "700",
                  color: brandCyan,
                  textTransform: "uppercase",
                  marginBottom: "8px",
                }}
              >
                02 / Our Vision
              </div>

              <h3
                style={{
                  margin: "0 0 12px",
                  fontSize: "20px",
                  fontWeight: "700",
                  color: "#111827",
                }}
              >
                Inspiring Modern Interior Living
              </h3>

              <p
                style={{
                  margin: "0 0 10px",
                  fontSize: "14px",
                  lineHeight: "1.6",
                  color: "#64748b",
                }}
              >
                Be the first choice for furniture materials and an inspiration
                in interior design by offering world-class production, top-notch
                products, and outstanding customer service.
              </p>

              <p
                style={{
                  margin: 0,
                  fontSize: "14px",
                  lineHeight: "1.6",
                  color: "#64748b",
                }}
              >
                We aim to build a furniture brand that people can trust for
                quality, design, comfort, and long-term value.
              </p>
            </div>
          </div>
        </section>

        {/* ================= WHY CHOOSE US ================= */}
        <section style={{ marginBottom: "50px" }}>
          <div
            style={{
              textAlign: "center",
              marginBottom: "32px",
            }}
          >
            <h2
              style={{
                margin: 0,
                fontSize: "28px",
                fontWeight: "800",
                color: brandPurple,
                textTransform: "uppercase",
              }}
            >
              WHY CHOOSE{" "}
              <span style={{ color: brandCyan }}>ICONIC FURNITURE</span>
            </h2>

            <p
              style={{
                margin: "8px 0 0",
                fontSize: "15px",
                color: "#64748b",
              }}
            >
              Designed with your lifestyle in mind.
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: "20px",
            }}
          >
            {whyChoose.map((item, index) => {
              const color = index % 2 === 0 ? brandPurple : brandCyan;

              return (
                <div
                  key={index}
                  style={{
                    border: `1px solid ${color}33`,
                    borderRadius: "12px",
                    padding: "20px",
                    background: "#fff",
                  }}
                >
                  <div
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "8px",
                      background: `${color}15`,
                      color: color,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "14px",
                      marginBottom: "12px",
                    }}
                  >
                    ✓
                  </div>

                  <h3
                    style={{
                      margin: "0 0 6px",
                      fontSize: "16px",
                      fontWeight: "700",
                      color: "#111827",
                    }}
                  >
                    {item.title}
                  </h3>

                  <p
                    style={{
                      margin: 0,
                      fontSize: "13px",
                      lineHeight: "1.5",
                      color: "#64748b",
                    }}
                  >
                    {item.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </section>

        {/* ================= OUR COMMITMENT ================= */}
        <section style={{ marginBottom: "40px" }}>
          <div
            style={{
              textAlign: "center",
              padding: "32px 20px",
              borderTop: `1px solid ${brandPurple}25`,
              borderBottom: `1px solid ${brandCyan}25`,
            }}
          >
            <h2
              style={{
                margin: "0 0 10px",
                fontSize: "24px",
                fontWeight: "800",
                color: "#111827",
              }}
            >
              Our Commitment
            </h2>

            <p
              style={{
                maxWidth: "800px",
                margin: "0 auto",
                fontSize: "15px",
                lineHeight: "1.6",
                color: "#64748b",
              }}
            >
              From product selection to customer service, we are committed to
              delivering furniture that adds comfort, functionality, and
              character to every space. We continuously work to improve our
              products and provide a better experience for our customers.
            </p>
          </div>
        </section>

        {/* ================= CTA ================= */}
        <section
          style={{
            textAlign: "center",
            padding: "36px 20px",
            borderRadius: "12px",
            background: "#f9fafb",
            border: `1px solid ${brandPurple}25`,
          }}
        >
          <h2
            style={{
              margin: "0 0 8px",
              fontSize: "24px",
              fontWeight: "800",
              color: "#111827",
            }}
          >
            Find Furniture for Your Space
          </h2>

          <p
            style={{
              margin: "0 auto 20px",
              fontSize: "15px",
              color: "#64748b",
            }}
          >
            Explore our collection and discover furniture made for modern
            living.
          </p>

          <button
            style={{
              border: "none",
              background: brandPurple,
              color: "#fff",
              padding: "12px 28px",
              borderRadius: "6px",
              fontSize: "14px",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            Explore Furniture →
          </button>
        </section>
      </div>

      {/* Responsive */}
      <style>
        {`
          @media (max-width: 900px) {
            section:first-child {
              grid-template-columns: 1fr !important;
            }

            section:first-child > div:last-child {
              height: 280px !important;
            }

            section:nth-of-type(2) > div:last-child,
            section:nth-of-type(5) > div:last-child {
              grid-template-columns: repeat(2, 1fr) !important;
            }
          }

          @media (max-width: 600px) {
            section:nth-of-type(2) > div:last-child,
            section:nth-of-type(5) > div:last-child {
              grid-template-columns: 1fr !important;
            }

            section:nth-of-type(4) > div {
              grid-template-columns: 1fr !important;
            }

            h1 {
              font-size: 28px !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default FurnitureAbout;
